import React from 'react';
import Divider from '@solid-ui-components/Divider';
import Box from 'theme-ui';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper';
import FeaturesTabOne from '@solid-ui-blocks/FeaturesWithPhoto/Block07';
import ContentText from '@solid-ui-components/ContentText';
import FeatureWithPhoto from '@elegantstack/solid-ui-blocks/src/FeaturesWithPhoto/Block09/Block09';
import styles from './styles';
import FlexContent from '@solid-ui-components/FlexContent/FlexContent';

const IndustryBlock06 = ({
  content,
  vertical,
  heading = true,

}) => (
  <>
    <LayoutWrapper >
      <Divider space={7} />
      <ContentText content={content['feature-photo-heading']?.text} sx={{ textAlign: 'center' }} />
      <FeatureWithPhoto content={content['info-block-1']}
        variant={'blue'}
        reverse
      />
      <Divider space={9} />
      <FeatureWithPhoto content={content['info-block-2']}
        variant={'blue'}
      />
      <Divider space={9} />
      <FeatureWithPhoto content={content['info-block-3']}
        variant={'blue'}
        reverse
      />
      <Divider space={9} />
      <FeatureWithPhoto content={content['info-block-4']}
        variant={'blue'}
      />
      <Divider />
    </LayoutWrapper>
  </>
);

export default IndustryBlock06;
